import styled from "styled-components";
export const StyledSignIn = styled.div`
  /* 親(StyledAppLayout)が display:flex のため、幅を明示しないと中身に引っ張られて親をはみ出す */
  width: 100%;

  /*
   * section > .container の型に合わせてある。
   *  - 縦の余白は index.css の section（80px / small 40px）が持つ
   *  - 横の余白は .container が持つ。ここでは付けない
   *  - height:100vh / width:100vw は iOS で事故が起きるため使わない（docs/design-rule.md §4）
   */
  .login {
    min-height:100vh;
    min-height:100dvh;
    background-color: ${(p) => p.theme.colors.white02};
    display:flex;
    flex-direction:column;
    justify-content:center;

    &__logo{
      display:block;
      width:100px;
      height:100px;
      object-fit:contain;
      margin:0 auto 16px;
    }

    /* 以前は $__title と書かれておりセレクタとして無効だった（色も効いていなかった）ため修正 */
    &__title {
      color: ${(p) => p.theme.palette.black.main};
      margin-bottom: 16px;
      text-align:left;
    }

    /* 横の余白は .container が持つので、ここでは付けない */
    &__middleContainer {
      width:100%;
      max-width:500px;
      margin:0 auto;
      text-align:left;
    }

    &__smallContainer {
      display:flex;
      flex-direction:column;
      align-items:center;
      margin:0 auto;
      width:100%;
      /* フォームを囲む白いカード。横幅は親(.login__middleContainer)に合わせる */
      padding:16px;
      background-color: ${(p) => p.theme.palette.white.main};
      border-radius:6px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    }

    &__input {
      padding:1.5rem 0;
      width:100%;
    }

    /* 入力欄とアイコンを重ねるための基準 */
    &__inputWrap {
      position:relative;
      width:100%;
      display:flex;
      align-items:center;
    }

    /* 左側の鍵アイコン */
    &__inputIcon {
      position:absolute;
      left:12px;
      top:50%;
      transform:translateY(-50%);
      display:flex;
      align-items:center;
      pointer-events:none;
    }

    /* 右側の目のアイコン。入力欄の中に収める */
    .eye-icon {
      position:absolute;
      right:4px;
      top:50%;
      transform:translateY(-50%);
    }

    &__check {
      padding: 0 0 2rem 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    &__button {
      display: flex;
      justify-content: center;
      align-items: center;

    }

    &__forgot {
     cursor: pointer;

    }


  }


    .SignIn {
        overflow: hidden;
        position: relative;
        max-height: 100vh;
        @media (min-width: ${(p) => p.theme.breakPoints.breakLarge}) {
            max-height: 100%;
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakBig}) {
            max-height: 100%;
        }
        /* @media (min-width: ${(p) => p.theme.breakPoints.breakBig}) {
            max-height: 100vh;
        } */
        &__iconBg {
            z-index: -1;
            position: absolute;
            right: -0.5rem;
            top: 13.2rem;
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                right: 4rem;
                top: 10rem;
            }
        }
        .link {
            font-size: 12px;
            color: ${(p) => p.theme.colors.secondary};
            margin-top: 60px;
            margin-bottom: 20px;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                margin-top: 120px;
                text-align: left;
            }
            span {
                word-spacing: -1px;
            }
        }
        &__left {
            width: 100%;
            height: 100vh;
            @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                display: none;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakLarge}) {
                height: 100%;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakBig}) {
                height: 100vh;
            }

            &-bg {
                width: 100%;
                height: 100%;
            }
        }
        &__content {
            display: flex;
            justify-content: center;
            padding: 0 60px;
            flex-direction: column;
            height: 100vh;
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                padding: 60px 160px;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakIpadPro}) {
                text-align: left;
                padding-top: 160px;
                padding: 60px 80px;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakLarge}) {
                height: 100%;
                padding: 60px 160px;
                padding-top: 160px;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakBig}) {
                padding: 60px 200px;
                height: 100%;
            }
        }
        &__form {
            width: 100%;
            &-title {
                font-family: ${(p) => p.theme.fontFamily.MochiyPopOne_Regular};
                font-size: 52px;
                padding-top: 2rem;
            }
            &-wrapper {
                width: 100%;
            }
            &-input {
                margin-top: 24px;
                width: 100%;
            }
            &-btn {
                padding-top: 45px;
            }
            &-checkbox {
                text-align: left;
                margin-top: 24px;
                .Mui-checked {
                    color: ${(p) => p.theme.colors.primary} !important;
                }
                svg {
                    width: 2em;
                    height: 2em;
                }

                .MuiFormControlLabel-label {
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_400};
                    font-size: 12px;
                    color: ${(p) => p.theme.colors.gray1};
                }
            }
        }
    }
`;
